module.exports = __webpack_public_path__ + "img/Posti.427d72db.png";